export default {
      id: "Icon--badgeSeenYear-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--badgeSeenYear",
      toString: function () {
        return this.url;
      }
    }